//Angular imports
import {Injectable} from '@angular/core';

@Injectable()
export class PaginationService {

    public defaultNumber: number = 0;
    public currentNumber: number = 0;
    public mobileDefaultNumber: number = 15;
    public tabletDefaultNumber: number = 20;
    public desktopDefaultNumber: number = 30;

    //default UBC value
    public mobileInitialNumber: number = 15;
    public tabletInitialNumber: number = 20;
    public desktopInitialNumber: number = 30;

    private defaultNumberUBC: number = 0;
    private currentNumberUBC: number = 0;

    public constructor() {}

    /**
     * Load More Pagination
     *
     * @param {any} data coming from api call, contains products
     * @param {boolean} see if the load more button is triggered
     */
    /*  */
    public loadCoupons(data: any, isLoadMoreActive: boolean) {
        let items: any = [];
        /* Increment number of coupons */
        this.currentNumber = isLoadMoreActive ? this.defaultNumber + this.currentNumber : 0;

        /* Retrieve Coupons based on the number of coupons given */
        data.slice(0, (this.currentNumber + this.defaultNumber)).forEach((item: any) => {
            items.push(item);
        });

        return items;
    }

    public loadCouponsUDC(data: any, isLoadMoreActive: boolean) {
        let items: any = [];
        /* Increment number of coupons */
        this.currentNumberUBC = isLoadMoreActive ? this.defaultNumberUBC + this.currentNumberUBC : 0;

        /* Retrieve Coupons based on the number of coupons given */
        data.slice(0, (this.currentNumberUBC + this.defaultNumberUBC)).forEach((item: any) => {
            items.push(item);
        });

        return items;
    }

    public setPaginationNumbers(mobileDefaultNumber: number, tabletDefaultNumber: number, desktopDefaultNumber: number){
        this.mobileDefaultNumber = Number(mobileDefaultNumber);
        this.tabletDefaultNumber = Number(tabletDefaultNumber);
        this.desktopDefaultNumber = Number(desktopDefaultNumber);

        //Grab the defaultNumber suited for the device; breakpoints are from bootstrap media queries
        if(window.innerWidth < 768){
            this.defaultNumber = this.mobileDefaultNumber;
        } else if(window.innerWidth >= 768 && window.innerWidth <= 992){
            this.defaultNumber = this.tabletDefaultNumber;
        } else if (window.innerWidth > 992){
            this.defaultNumber = this.desktopDefaultNumber;
        }
    }

    public setPaginationNumbersUBC(mobileDefaultNumberUBC: number, tabletDefaultNumberUBC: number, desktopDefaultNumberUBC: number){
       //Grab the defaultNumber suited for the device; breakpoints are from bootstrap media queries
       if(window.innerWidth < 768){
                this.defaultNumberUBC = isNaN(Number(mobileDefaultNumberUBC))?this.mobileInitialNumber:Number(mobileDefaultNumberUBC);
       } else if(window.innerWidth >= 768 && window.innerWidth <= 992){
                this.defaultNumberUBC = isNaN(Number(tabletDefaultNumberUBC))?this.tabletInitialNumber:Number(tabletDefaultNumberUBC);
       } else if (window.innerWidth > 992){
                this.defaultNumberUBC = isNaN(Number(desktopDefaultNumberUBC))?this.desktopInitialNumber:Number(desktopDefaultNumberUBC);
       }
    }
}

